<template>
  <div class="dashboard-nav dashboard--nav">

    <!--<div class="container-fluid">-->
      <!--      <div class="row">-->
      <!--        <div class="col-lg-12">-->
      <!--          <div class="menu-wrapper">-->
      <!--            <div class="logo mr-5">-->
      <!--              <a href="/"><img :src="'/vendor/images/logo.png'" alt="logo"></a>-->
      <!--              <div class="menu-toggler">-->
      <!--                <i class="la la-bars"></i>-->
      <!--                <i class="la la-times"></i>-->
      <!--              </div>&lt;!&ndash; end menu-toggler &ndash;&gt;-->
      <!--              <div class="user-menu-open">-->
      <!--                <i class="la la-user"></i>-->
      <!--              </div>&lt;!&ndash; end user-menu-open &ndash;&gt;-->
      <!--            </div>-->
      <!--            <div class="dashboard-search-box">-->
      <!--              <div class="contact-form-action">-->
      <!--              </div>-->
      <!--            </div>-->
      <!--            <div class="nav-btn ml-auto">-->
      <!--              <div class="notification-wrap d-flex align-items-center">-->
      <!--                <div class="notification-item">-->
      <!--                  <div class="dropdown">-->
      <!--                    <a href="#" class="dropdown-toggle" id="userDropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
      <!--                      <div class="d-flex align-items-center">-->
      <!--                        <div class="avatar avatar-sm flex-shrink-0 mr-2"></div>-->
      <!--&lt;!&ndash;                        <span class="font-size-14 font-weight-bold">{{ user }}</span>&ndash;&gt;-->
      <!--                      </div>-->
      <!--                    </a>-->
      <!--                    <div class="dropdown-menu dropdown-reveal dropdown-menu-md dropdown-menu-right">-->
      <!--                      <div class="dropdown-item drop-reveal-header user-reveal-header">-->
      <!--                        <h6 class="title text-uppercase">Welcome!</h6>-->
      <!--                      </div>-->
      <!--                      <div class="list-group drop-reveal-list user-drop-reveal-list">-->
      <!--                        <div class="section-block"></div>-->
      <!--                        <a href="/logout" class="list-group-item list-group-item-action">-->
      <!--                          <div class="msg-body">-->
      <!--                            <div class="msg-content">-->
      <!--                              <h3 class="title"><i class="la la-power-off mr-2"></i>Logout</h3>-->
      <!--                            </div>-->
      <!--                          </div>&lt;!&ndash; end msg-body &ndash;&gt;-->
      <!--                        </a>-->
      <!--                      </div>-->
      <!--                    </div>&lt;!&ndash; end dropdown-menu &ndash;&gt;-->
      <!--                  </div>-->
      <!--                </div>&lt;!&ndash; end notification-item &ndash;&gt;-->
      <!--              </div>-->
      <!--            </div>&lt;!&ndash; end nav-btn &ndash;&gt;-->
      <!--          </div>&lt;!&ndash; end menu-wrapper &ndash;&gt;-->
      <!--        </div>&lt;!&ndash; end col-lg-12 &ndash;&gt;-->
      <!--      </div>&lt;!&ndash; end row &ndash;&gt;-->
      <!--    </div>&lt;!&ndash; end container-fluid &ndash;&gt;-->

    <div class="header-top-content">
      <div class="d-flex">
        <div class="flex header-right d-flex align-items-center justify-content-start">
          <i style="color: whitesmoke" @click="toggleMenu()" class="la la-solid la-bars la-2x ml-2"></i>
        </div>
        <div class="header-right d-flex align-items-center justify-content-end mr-3">
          <div class="header-right-action" style="border: 0.5px solid #ffffff;border-radius: 5px;padding: 6px;padding-left: 17px;margin-right: 20px;">
            <div class="select-contain select--contain w-auto top-lang">
              <select class="select-contain-select lang-select" style="color: whitesmoke" v-model="locale">
                <option :value="'EN'" :selected="locale==='EN'" data-content='<span class="flag-icon flag-icon-us mr-1"></span> English'>English</option>
                <option :value="'TR'" :selected="locale==='TR'" data-content='<span class="flag-icon flag-icon-tr mr-1"></span> Türkçe'>Türkçe</option>
                <option v-if="projectName === 'selectum'" :value="'RU'" :selected="locale==='RU'" data-content='<span class="flag-icon flag-icon-ru mr-1"></span> Rusça'>Rusça</option>
                <option v-if="projectName === 'selectum'" :value="'DE'" :selected="locale==='DE'" data-content='<span class="flag-icon flag-icon-de mr-1"></span> Almanca'>Almanca</option>
              </select>
            </div>
          </div>
          <div class="header-right-action" v-if="user !== null">
            <span class="font-size-14 font-weight-bold" style="color: whitesmoke">{{ user.email }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "TopBar",
  computed:{
    locale:{
      get(){
        return this.$store.getters.getLocale;
      },
      set(value){
        return this.$store.commit("setLocale", value);
      }
    },
    user:{
      get(){
        return this.$store.getters.getUser;
      }
    },
    projectName:{
      get(){
        return this.$store.getters.getProjectName;
      }
    }
  },
  methods:{
    toggleMenu:function (){
      if(!$(".sidebar--nav").hasClass("active")){
        $(".sidebar--nav").addClass("active")
      }else{
        $(".sidebar--nav").removeClass("active")
      }
    }
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>